import React from 'react'

const PlayfairCipherTheory = () => {
    return (
        <div>
            <ul>
                <li>
                    <p>
                    Vigenere Cipher is a method of encrypting alphabetic text. It uses a simple form of polyalphabetic substitution. A polyalphabetic cipher is any cipher based on substitution, using multiple substitution alphabets. The encryption of the original text is done using the Vigenère square or Vigenère table.
                    </p>
                </li>
                <li>
                    <p>
                    The table consists of the alphabets written out 26 times in different rows, each alphabet shifted cyclically to the left compared to the previous alphabet, corresponding to the 26 possible Caesar Ciphers.
                    </p>
                </li>
                <li>
                    <p>
                    At different points in the encryption process, the cipher uses a different alphabet from one of the rows.
                    </p>
                </li>
                <li>
                    <p>
                    The alphabet used at each point depends on a repeating keyword.
                    </p>
                </li>
            </ul>
        </div>
    )
}

export default PlayfairCipherTheory